import { DocFilterInterface } from '../interfaces/doc-filter.interface';
import { DocFilterContentModel } from './doc-filter-content.model';

export class DocFiltersModel {
  /**
   * Id
   */
  id: number;

  /**
   * Name
   */
  name: string;

  /**
   * CreatedBy
   */
  createdBy: number;

  /**
   * Shared
   */
  shared: boolean;

  /**
   * CreatedDate
   */
  createdDate: number;

  /**
   * UpdatedDate
   */
  updatedDate: number;

  /**
   * Content
   */
  content: DocFilterContentModel;

  /**
   * Creates an instance of DocFilterInterface.
   *
   * @param data - Doc filter info
   */
  constructor(data: DocFilterInterface) {
    this.id = data.id;
    this.name = data.name;
    this.createdBy = data.createdBy;
    this.shared = data.shared;
    this.createdDate = data.createdDate;
    this.updatedDate = data.updatedDate;
    this.content = new DocFilterContentModel(data.content);
  }
}
